import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { ILanguageComplianceFilter } from '../../model/types/LanguageComplianceFilter.interface'
import { selectLanguageComplianceFilter } from '../../model/languageComplianceSlice'
import { useExportLanguageComplianceHistory } from '../../../../app/api'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { IconUpload } from '../../../../shared/components/icons/IconUpload'
import clsx from 'clsx'
import styles from './LanguageCompiliancePanel.module.scss'

export const LanguageCompiliancePanel = () => {
  const filters = useAppSelector<ILanguageComplianceFilter>(selectLanguageComplianceFilter)
  const { project, country, url, affiliate, dateRange, restrictedWords, hidden } = filters
  const [queryParams, setQueryParams] = useState<any>()

  const [exportHistory, { isFetching: exportLoading }] = useExportLanguageComplianceHistory()

  useEffect(() => {
    setQueryParams({
      date: dateRange,
      projectId: Number(project),
      countryId: country,
      urlId: url || undefined,
      affiliate: affiliate,
      wordId: restrictedWords || undefined,
      showHidden: hidden,
    })
  }, [filters])

  return (
    <div className={clsx(styles.root)}>
      <BpButton
        className={clsx(styles.button)}
        iconLeft={<IconUpload />}
        loading={exportLoading}
        size='sm'
        theme='outline'
        type='button'
        onClick={() => exportHistory({ ...queryParams })}
      >
        Export
      </BpButton>
    </div>
  )
}
